<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="推广记录" />
    </van-sticky>
		<div class="search-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="(item,index) in tabData" :key="index" :class="'testing'">
          <!-- 信息 -->
          <div class="flex-row-between" style="padding-right: 16px">
            <!-- <div class="baseinfo flex-row-start">
              <div v-if="item.studentBasePO.name" class="font-intro">姓名：{{ item.studentBasePO.name }}</div>
              <div v-if="item.userAuthPO.name" class="font-intro">姓名：{{ item.userAuthPO.name }}</div>
            </div> -->
            <div class="baseinfo flex-row-start">
              <div class="font-bigger">{{ item.nickName }}</div>
            </div>
            <div class="font-bigger name"></div>
          </div>
          <!-- <van-cell title="名称" :value="item.testingName" :border="false" /> -->
          <!-- 按钮 -->
          <div class="bottom flex-row-between">
            <div class="state">{{ item.tel }}</div>
            <div class="flex-row-end">
              <div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
		</div>
  </div>
</template>
<script>
import { fetchShareRecord } from "../../../api/user"
export default {
  data() {
    return {
      typeBg: {
        'User': '../../../assets/images/user-bg.png',
        'Student': '../../../assets/images/student-bg.png'
      },
      searchValue: '',
      offset: 100,//滚动条与底部距离小于 offset 时触发load事件，默认300
      pageNum: -1, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      tabData: []
    };
  },
  filters: {
  },
  components: {
  },
  created() {
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    init() {
      this.$nextTick(() => {
        this.handleButtonSearchInfors()
      })
    },
    //点击键盘上的搜索/回车按钮后触发
    handleEnterSearchInfors(val) {
      console.log(val);
    },
    handleButtonSearchInfors() {
      this.pageNum = 0
      this.tabData = []
      this.loadData()
    },
    // 滚动加载更多
    onLoad() {
      this.pageNum++
      this.loadData()
    },
    loadData() {
      fetchShareRecord({
        keyWord: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }, {}).then(res => {
        var data = res.content
        this.loading = false
        this.tabData = this.tabData.concat(data)
        if (data.length < this.pageSize) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.search-container {
  padding: 0.66667rem;
  background-repeat: no-repeat;
  background-size: 100%;
}
.van-search {
  border-radius: 20px;
  /deep/ .van-search__content {
    background-color: #31607b;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #999;
  }
  /deep/ input::-moz-input-placeholder {
    color: #999;
  }
  /deep/ input::-ms-input-placeholder {
    color: #999;
  }
  /deep/ .van-field__control {
    color: #c28831;
  }
}
.van-search__action {
  background-image: radial-gradient(#d8ba79, #c28831);
  padding: 0 32px;
  margin: 0 20px 0 0;
  color: #1b2026;
  border-radius: 20px;
  div {
    font-size: 30px;
  }
}
.search-list {
  padding: 0 40px 40px 40px;
  .testing {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background: #fff;
  }
}
.custom-title {
  color: #999999;
}
.name {
  padding: 24px 24px 0 24px;
}
.content {
  color: #999!important;
  margin-top: 16px;
  padding-left: 24px;
  div {
    color: #999!important;
    margin-top: 8px;
  }
}
.state {
  font-weight: bold;
  color: #ff9e19;
}
.bottom {
  font-size: .32rem;
  padding: 24px;
}
.baseinfo {
  margin-top: 24px;
  padding-left: 24px;
  .sex {
    width: 24px;
    height: 24px;
    margin-top: 8px;
    margin-left: 8px;
  }
}
.detailinfo {
  padding-left: 24px;
  padding-top: 8px;
}
.headimg {
  border-radius: 50%;
  height: 120px;
  width: 120px;
}
.font-bigger {
  padding-right: 0px;
}
.font-intro {
  padding-right: 16px;
}
</style>